import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { CONSTANTS, DEGREE_OPTIONS } from 'src/Core/Constant';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-educational-and-workexperience',
  templateUrl: './educational-and-workexperience.component.html',
  styleUrls: ['./educational-and-workexperience.component.scss']
})
export class EducationalAndWorkexperienceComponent {
  @Input() applicantData: any;
  @Input() isPreviewMode: boolean = false;
  @Output() previous = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();
  SaveMode = CONSTANTS.SAVE_MODE;
  submitted = false;
  lastSubmitMode: number | null = null;
  isJsonShow = environment.isJsonShow;
  selectedLanguage: string = 'en'; // Default language
  degreeOptions = DEGREE_OPTIONS;
  isEditable: boolean = true; // Flag to track if the form is editable
  
  educationaAndworkExperienceForm!: FormGroup;

  constructor(
    private toastr: ToastrService,
    private api : SevaProfileService,
    private fb: FormBuilder,
    public genericValidations: GenericValidationsService,
    private translationService: TranslationService
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();

    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.getApplicantData();
    }
  }

  // Get translation for current language
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {
 
  
      console.log(JSON.stringify (this.applicantData));
      this.initializeForm();
      this.bindApplicantData();
      this.educationaAndworkExperienceForm.disable();
    }
  }





  bindApplicantData() {

    // this execute only o preview mode

    // Patch scalar fields first (including HasEducation)
    const { UserEducation, UserWorkExperience, ...rest } = this.applicantData;
    this.educationaAndworkExperienceForm.patchValue(rest);

    // Get HasEducation value after patching
    const hasEducation = this.educationaAndworkExperienceForm.get('HasEducation')?.value;

    // Clear existing
    this.educationalFormArray.clear();
    this.workExperienceFormArray.clear();
  
    // Bind Education
    if (Array.isArray(this.applicantData.UserEducation) && this.applicantData.UserEducation.length) {
      this.applicantData.UserEducation.forEach((edu: any) => {
        const eduGroup = this.createEducationFormGroup(hasEducation === 'Yes');
        eduGroup.patchValue(edu);
        this.educationalFormArray.push(eduGroup);
      });
    } else {
      this.educationalFormArray.push(this.createEducationFormGroup(hasEducation === 'Yes'));
    }
  
    // Get HasWorkExperience value after patching
    const hasWorkExperience = this.educationaAndworkExperienceForm.get('HasWorkExperience')?.value;

    // Bind Work Experience
    if (Array.isArray(this.applicantData.UserWorkExperience) && this.applicantData.UserWorkExperience.length) {
      this.applicantData.UserWorkExperience.forEach((work: any) => {
        const workGroup = this.createWorkFormGroup(hasWorkExperience === 'Yes');
        workGroup.patchValue(work);
        this.workExperienceFormArray.push(workGroup);
      });
    } else {
      this.workExperienceFormArray.push(this.createWorkFormGroup(hasWorkExperience === 'Yes'));
    }
  }




  getApplicantData(){
    this.api.apiCall('WorkEducation/GetEducationAndWorkDetails', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage);

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.educationaAndworkExperienceForm.disable();
        } else {
          this.educationaAndworkExperienceForm.enable();
        }

        const data = response.Data;
        const educationList = Array.isArray(data.UserEducation) ? data.UserEducation : [];
        const workList = Array.isArray(data.UserWorkExperience) ? data.UserWorkExperience : [];

        // Patch scalar fields first (including HasEducation) to set up validators correctly
        const { UserEducation, UserWorkExperience, ...rest } = data;
        this.educationaAndworkExperienceForm.patchValue(rest);

        // Get HasEducation value after patching
        const hasEducation = this.educationaAndworkExperienceForm.get('HasEducation')?.value;

        // Repopulate UserEducation FormArray
        this.educationalFormArray.clear();
        if (educationList.length > 0) {
          educationList.forEach((edu: any) => {
            const eduGroup = this.createEducationFormGroup(hasEducation === 'Yes');
            eduGroup.patchValue(edu);
            this.educationalFormArray.push(eduGroup);
          });
        } else {
          this.educationalFormArray.push(this.createEducationFormGroup(hasEducation === 'Yes'));
        }

        // Get HasWorkExperience value after patching
        const hasWorkExperience = this.educationaAndworkExperienceForm.get('HasWorkExperience')?.value;

        // Repopulate UserWorkExperience FormArray
        this.workExperienceFormArray.clear();
        if (workList.length > 0) {
          workList.forEach((work: any) => {
            const workGroup = this.createWorkFormGroup(hasWorkExperience === 'Yes');
            workGroup.patchValue(work);
            this.workExperienceFormArray.push(workGroup);
          });
        } else {
          this.workExperienceFormArray.push(this.createWorkFormGroup(hasWorkExperience === 'Yes'));
        }
      }
    })
  }




  get educationalFormArray() {
    return this.educationaAndworkExperienceForm.get('UserEducation') as FormArray;
  }

  get workExperienceFormArray() {
    return this.educationaAndworkExperienceForm.get('UserWorkExperience') as FormArray;
  }

  // Get complete form data
  get formData() {
    return this.educationaAndworkExperienceForm.value;
  }

  // Check if the entire form is valid
  get isFormValid(): boolean {
    return this.hasValidEducationData() && this.hasValidWorkData();
  }

  // Check if at least one education row has all required fields filled
  hasValidEducationData(): boolean {
    // If HasEducation is "No" or null, education data is not required
    const hasEducation = this.educationaAndworkExperienceForm.get('HasEducation')?.value;
    if (hasEducation === 'No') {
      return true; // Education is not required
    }
    if (hasEducation === null || hasEducation === undefined || hasEducation === '') {
      return false; // HasEducation must be answered
    }

    const UserEducation = this.educationalFormArray.value;
    return UserEducation.some((education: any) => {
      return education.DegreeName && 
             education.SpecializationName && 
             education.University && 
             education.YearCompleted &&
             this.isEducationYearValid(education.YearCompleted);
    });
  }

  // Check if at least one work experience row has all required fields filled
  hasValidWorkData(): boolean {
    // If HasWorkExperience is "No" or null, work experience data is not required
    const hasWorkExperience = this.educationaAndworkExperienceForm.get('HasWorkExperience')?.value;
    if (hasWorkExperience === 'No') {
      return true; // Work experience is not required
    }
    if (hasWorkExperience === null || hasWorkExperience === undefined || hasWorkExperience === '') {
      return false; // HasWorkExperience must be answered
    }

    const UserWorkExperience = this.workExperienceFormArray.value;
    return UserWorkExperience.some((work: any) => {
      return work.CompanyName && 
             work.JobDesignation && 
             work.JobStartDate && 
             work.JobEndDate && 
             work.FieldTradeName &&
             this.isYearValid(work.JobStartDate) &&
             this.isYearValid(work.JobEndDate);
    });
  }

  // Helper method to check if a year is valid (exactly 4 digits and not future)
  private isYearValid(year: any): boolean {
    if (!year) return false;
    
    const yearStr = year.toString();
    if (yearStr.length !== 4 || !/^\d{4}$/.test(yearStr)) {
      return false;
    }
    
    const yearNum = parseInt(yearStr);
    const currentYear = new Date().getFullYear();
    
    return yearNum <= currentYear;
  }

  // Helper method to check if an education year is valid (exactly 4 digits, allows future years)
  private isEducationYearValid(year: any): boolean {
    if (!year) return false;
    
    const yearStr = year.toString();
    if (yearStr.length !== 4 || !/^\d{4}$/.test(yearStr)) {
      return false;
    }
    
    return true; // Allow future years for education
  }

  // Check if any year fields have validation errors in Education section only
  hasEducationYearValidationErrors(): boolean {
    return this.educationalFormArray.controls.some(control => {
      const yearControl = control.get('YearCompleted');
      return yearControl?.errors && Object.keys(yearControl.errors).length > 0;
    });
  }

  // Check if any year fields have validation errors in Work Experience section only
  hasWorkYearValidationErrors(): boolean {
    return this.workExperienceFormArray.controls.some(control => {
      const fromYearControl = control.get('JobStartDate');
      const toYearControl = control.get('JobEndDate');
      return (fromYearControl?.errors && Object.keys(fromYearControl.errors).length > 0) ||
             (toYearControl?.errors && Object.keys(toYearControl.errors).length > 0) ||
             (control.errors && Object.keys(control.errors).length > 0); // Form group level errors
    });
  }

  // Check if any year fields have validation errors (both sections - kept for backward compatibility)
  hasYearValidationErrors(): boolean {
    return this.hasEducationYearValidationErrors() || this.hasWorkYearValidationErrors();
  }

  // Check if the last education row is complete
  isLastEducationRowComplete(): boolean {
    const lastIndex = this.educationalFormArray.length - 1;
    if (lastIndex < 0) return false;
    
    const lastRow = this.educationalFormArray.at(lastIndex);
    return lastRow.get('DegreeName')?.value && 
           lastRow.get('SpecializationName')?.value && 
           lastRow.get('University')?.value && 
           lastRow.get('YearCompleted')?.value &&
           this.isEducationYearValid(lastRow.get('YearCompleted')?.value) &&
           !lastRow.errors; // Also check for form group level errors
  }

  // Check if the last work experience row is complete
  isLastWorkRowComplete(): boolean {
    const lastIndex = this.workExperienceFormArray.length - 1;
    if (lastIndex < 0) return false;
    
    const lastRow = this.workExperienceFormArray.at(lastIndex);
    return lastRow.get('CompanyName')?.value && 
           lastRow.get('JobDesignation')?.value && 
           lastRow.get('JobStartDate')?.value && 
           lastRow.get('JobEndDate')?.value && 
           lastRow.get('FieldTradeName')?.value &&
           this.isYearValid(lastRow.get('JobStartDate')?.value) &&
           this.isYearValid(lastRow.get('JobEndDate')?.value) &&
           !lastRow.errors; // Also check for form group level errors (year range validation)
  }

  // Check if a specific education row is complete
  isEducationRowComplete(index: number): boolean {
    const row = this.educationalFormArray.at(index);
    return row.get('DegreeName')?.value && 
           row.get('SpecializationName')?.value && 
           row.get('University')?.value && 
           row.get('YearCompleted')?.value;
  }

  // Check if a specific work experience row is complete
  isWorkRowComplete(index: number): boolean {
    const row = this.workExperienceFormArray.at(index);
    return row.get('CompanyName')?.value && 
           row.get('JobDesignation')?.value && 
           row.get('JobStartDate')?.value && 
           row.get('JobEndDate')?.value && 
           row.get('FieldTradeName')?.value;
  }

  // Custom validator for work experience year range
  private workYearRangeValidator(group: AbstractControl): { [key: string]: any } | null {
    const JobStartDate = group.get('JobStartDate')?.value;
    const JobEndDate = group.get('JobEndDate')?.value;
    
    if (!JobStartDate || !JobEndDate) {
      return null; // Let required validators handle empty values
    }
    
    const fromYearNum = parseInt(JobStartDate.toString());
    const toYearNum = parseInt(JobEndDate.toString());
    const currentYear = new Date().getFullYear();
    
    // Check if either year is greater than current year
    if (fromYearNum > currentYear || toYearNum > currentYear) {
      return { 'yearFuture': true };
    }
    
    // Check if To Year is less than From Year (allow equal years)
    if (toYearNum < fromYearNum) {
      return { 'invalidYearRange': true };
    }
    
    return null;
  }

  // Custom validator for 4-digit year (used for work experience - checks future years)
  private yearValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }
    
    const year = control.value.toString();
    
    // Check if exactly 4 digits
    if (year.length !== 4) {
      return { 'invalidYearLength': true };
    }
    
    // Check if all characters are digits
    if (!/^\d{4}$/.test(year)) {
      return { 'invalidYearFormat': true };
    }
    
    const yearNum = parseInt(year);
    const currentYear = new Date().getFullYear();
    
    // Check if year is greater than current year
    if (yearNum > currentYear) {
      return { 'yearFuture': true };
    }
    
    return null;
  }

  // Custom validator for education year (allows future years)
  private educationYearValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }
    
    const year = control.value.toString();
    
    // Check if exactly 4 digits
    if (year.length !== 4) {
      return { 'invalidYearLength': true };
    }
    
    // Check if all characters are digits
    if (!/^\d{4}$/.test(year)) {
      return { 'invalidYearFormat': true };
    }
    
    // No future year check for education - allow future years
    return null;
  }

  initializeForm() {
    // Initialize unified form with both education and work experience
    this.educationaAndworkExperienceForm = this.fb.group({
      SaveMode: ['', Validators.required],
      HasEducation: [null, Validators.required],
      HasWorkExperience: [null, Validators.required],
      UserEducation: this.fb.array([
        this.createEducationFormGroup(false) // Initially no validators
      ]),
      UserWorkExperience: this.fb.array([
        this.createWorkFormGroup(false) // Initially no validators
      ])
    });

    // Setup conditional validation for HasEducation and HasWorkExperience
    this.setupHasEducationValidation();
    this.setupHasWorkExperienceValidation();
  }

  private createEducationFormGroup(hasValidators: boolean = true): FormGroup {
    const validators = hasValidators ? {
      DegreeName: [Validators.required, Validators.maxLength(50)],
      SpecializationName: [Validators.required, Validators.maxLength(50)],
      University: [Validators.required, Validators.maxLength(50)],
      YearCompleted: [Validators.required, this.educationYearValidator.bind(this)]
    } : {
      DegreeName: [Validators.maxLength(50)],
      SpecializationName: [Validators.maxLength(50)],
      University: [Validators.maxLength(50)],
      YearCompleted: [this.educationYearValidator.bind(this)]
    };

    return this.fb.group({
      Id: [0],
      DegreeName: ['', validators.DegreeName],
      SpecializationName: ['', validators.SpecializationName],
      University: ['', validators.University],
      YearCompleted: ['', validators.YearCompleted],
      SaveMode: [0]
    });
  }

  private createWorkFormGroup(hasValidators: boolean = true): FormGroup {
    const fieldValidators = hasValidators ? {
      CompanyName: [Validators.required, Validators.maxLength(50)],
      JobDesignation: [Validators.required, Validators.maxLength(50)],
      JobStartDate: [Validators.required, this.yearValidator.bind(this)],
      JobEndDate: [Validators.required, this.yearValidator.bind(this)],
      FieldTradeName: [Validators.required, Validators.maxLength(50)]
    } : {
      CompanyName: [Validators.maxLength(50)],
      JobDesignation: [Validators.maxLength(50)],
      JobStartDate: [this.yearValidator.bind(this)],
      JobEndDate: [this.yearValidator.bind(this)],
      FieldTradeName: [Validators.maxLength(50)]
    };

    const groupOptions = hasValidators 
      ? { validators: this.workYearRangeValidator.bind(this) }
      : {};

    return this.fb.group({
      Id: [0],
      CompanyName: ['', fieldValidators.CompanyName],
      JobDesignation: ['', fieldValidators.JobDesignation],
      JobStartDate: ['', fieldValidators.JobStartDate],
      JobEndDate: ['', fieldValidators.JobEndDate],
      FieldTradeName: ['', fieldValidators.FieldTradeName],
      SaveMode: [0]
    }, groupOptions);
  }

  addEducationRow() {
    // Only allow adding if the last education row is complete and no education year validation errors
    if (this.isLastEducationRowComplete() && !this.hasEducationYearValidationErrors()) {
      const hasEducation = this.educationaAndworkExperienceForm.get('HasEducation')?.value;
      this.educationalFormArray.push(this.createEducationFormGroup(hasEducation === 'Yes'));
    } else {
      // Do not toggle global submitted flag here; just mark the last row as touched
      // Mark the last education row as touched to show validation styling
      const lastIndex = this.educationalFormArray.length - 1;
      if (lastIndex >= 0) {
        const lastRow = this.educationalFormArray.at(lastIndex);
        lastRow.markAllAsTouched();
      }
    }
  }

  removeEducationRow(index: number) {
    if (this.educationalFormArray.length > 1) {
      this.educationalFormArray.removeAt(index);
    }
  }

  addWorkRow() {
    // Only allow adding if the last work experience row is complete and no work experience year validation errors
    if (this.isLastWorkRowComplete() && !this.hasWorkYearValidationErrors()) {
      const hasWorkExperience = this.educationaAndworkExperienceForm.get('HasWorkExperience')?.value;
      this.workExperienceFormArray.push(this.createWorkFormGroup(hasWorkExperience === 'Yes'));
    } else {
      // Do not toggle global submitted flag here; just mark the last row as touched
      // Mark the last work experience row as touched to show validation styling
      const lastIndex = this.workExperienceFormArray.length - 1;
      if (lastIndex >= 0) {
        const lastRow = this.workExperienceFormArray.at(lastIndex);
        lastRow.markAllAsTouched();
      }
    }
  }

  removeWorkRow(index: number) {
    if (this.workExperienceFormArray.length > 1) {
      this.workExperienceFormArray.removeAt(index);
    }
  }

  // Get validation errors for display
  getValidationErrors(): { education: string[], work: string[] } {
    const errors: { education: string[], work: string[] } = { education: [], work: [] };

    // Check education validation
    if (!this.hasValidEducationData()) {
      errors.education.push('At least one educational record must be completed with valid data');
    }

    // Check work experience validation
    if (!this.hasValidWorkData()) {
      errors.work.push('At least one work experience record must be completed with valid data');
    }

    // Check for specific year validation errors
    this.educationalFormArray.controls.forEach((control, index) => {
      const yearControl = control.get('YearCompleted');
      if (yearControl?.errors) {
        if (yearControl.errors['invalidYearLength']) {
          errors.education.push(`Row ${index + 1}: Year must be exactly 4 digits`);
        } else if (yearControl.errors['invalidYearFormat']) {
          errors.education.push(`Row ${index + 1}: Year must contain only numbers`);
        }
        // Note: yearFuture error removed for education - future years are allowed
      }
    });

    this.workExperienceFormArray.controls.forEach((control, index) => {
      const fromYearControl = control.get('JobStartDate');
      const toYearControl = control.get('JobEndDate');
      
      // Check individual field errors
      if (fromYearControl?.errors) {
        if (fromYearControl.errors['invalidYearLength']) {
          errors.work.push(`Row ${index + 1}: From year must be exactly 4 digits`);
        } else if (fromYearControl.errors['invalidYearFormat']) {
          errors.work.push(`Row ${index + 1}: From year must contain only numbers`);
        } else if (fromYearControl.errors['yearFuture']) {
          errors.work.push(`Row ${index + 1}: From year cannot be greater than current year`);
        }
      }
      
      if (toYearControl?.errors) {
        if (toYearControl.errors['invalidYearLength']) {
          errors.work.push(`Row ${index + 1}: To year must be exactly 4 digits`);
        } else if (toYearControl.errors['invalidYearFormat']) {
          errors.work.push(`Row ${index + 1}: To year must contain only numbers`);
        } else if (toYearControl.errors['yearFuture']) {
          errors.work.push(`Row ${index + 1}: To year cannot be greater than current year`);
        }
      }
      
      // Check form group level errors (year range validation)
      if (control.errors) {
        if (control.errors['yearFuture']) {
          errors.work.push(`Row ${index + 1}: Years cannot be greater than current year`);
        } else if (control.errors['invalidYearRange']) {
          errors.work.push(`Row ${index + 1}: To year must be greater than or equal to From year`);
        }
      }
    });

    return errors;
  }

  private initializeForm1() {
    // Load existing educational data if available
    if (this.applicantData.education && this.applicantData.education.length > 0) {
      this.educationalFormArray.clear();
      this.applicantData.education.forEach((edu: any) => {
        this.educationalFormArray.push(this.fb.group({
          DegreeName: [edu.DegreeName || '', Validators.required],
          SpecializationName: [edu.SpecializationName || '', Validators.required],
          University: [edu.University || '', Validators.required],
          YearCompleted: [edu.YearCompleted || '', [Validators.required, this.educationYearValidator.bind(this)]]
        }));
      });
    }

    // Load existing work experience data if available
    if (this.applicantData.workExperience && this.applicantData.workExperience.length > 0) {
      this.workExperienceFormArray.clear();
      this.applicantData.workExperience.forEach((work: any) => {
        this.workExperienceFormArray.push(this.fb.group({
          CompanyName: [work.CompanyName || '', Validators.required],
          JobDesignation: [work.JobDesignation || '', Validators.required],
          JobStartDate: [work.JobStartDate || '', [Validators.required, this.yearValidator.bind(this)]],
          JobEndDate: [work.JobEndDate || '', [Validators.required, this.yearValidator.bind(this)]],
          FieldTradeName: [work.FieldTradeName || '', Validators.required]
        }, { validators: this.workYearRangeValidator.bind(this) }));
      });
    }
  }

  goToBack() {
    this.previous.emit();
  }

  goToNext() {
    // Implementation for next step
  }

  onSubmit(Mode: number): void {
    this.lastSubmitMode = Mode;
    this.submitted = (Mode === this.SaveMode.SAVE);
    
   
    this.educationaAndworkExperienceForm.patchValue({
      // SaveMode: Mode,
      UserEducation:this.educationalFormArray.value,
      UserWorkExperience: this.workExperienceFormArray.value

    })
    


  
    if (!this.educationaAndworkExperienceForm.valid && Mode ==  this.SaveMode.SAVE) {
        // Mark all inner controls as touched to surface errors
        this.educationalFormArray.controls.forEach(group => group.markAllAsTouched());
        this.workExperienceFormArray.controls.forEach(group => group.markAllAsTouched());
     
        this.toastr.warning(this.getTranslation('validation.completeAllFields'));

        return
    }
    
   

    const formValue = this.educationaAndworkExperienceForm.value;

    // Check and update UserEducation array
    if (formValue.UserEducation && Array.isArray(formValue.UserEducation)) {
      formValue.UserEducation = formValue.UserEducation.map((edu: any) => ({
        ...edu,
        SaveMode: Mode,
        YearCompleted: edu.YearCompleted != null ? String(edu.YearCompleted) : ''
      }));
    }
  
    // Check and update UserWorkExperience array
    if (formValue.UserWorkExperience && Array.isArray(formValue.UserWorkExperience)) {
      formValue.UserWorkExperience = formValue.UserWorkExperience.map((work: any) => ({
        ...work,
        SaveMode: Mode,
        JobStartDate: work.JobStartDate != null ? String(work.JobStartDate) : '',
    JobEndDate: work.JobEndDate != null ? String(work.JobEndDate) : ''
      }));
    }
  



    
    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(formValue);
    this.addUpdate(cleanedValues, Mode);
    
    




  }





  
addUpdate(reqBoby: any, Mode: number) {
  reqBoby.SaveMode = Mode;
  this.api.apiCall('WorkEducation/SaveEducationAndWorkDetails', 'POST', reqBoby).subscribe((response: any) => {
    console.log('POST response:', response);
    this.toastr.success( response?.Message);
    if (Mode ==  this.SaveMode.SAVE) {
      this.nextStep.emit();
    }else if(Mode ==  this.SaveMode.DRAFT){
      this.getApplicantData();
    }
  });
}

  // Get tooltip for Add Education button
  getEducationAddButtonTooltip(): string {
    if (!this.isLastEducationRowComplete()) {
      return 'Please complete the current education row before adding a new one';
    }
    if (this.hasEducationYearValidationErrors()) {
      return 'Please fix validation errors in education section before adding new rows';
    }
    return 'Add new education record';
  }

  // Get tooltip for Add Work Experience button
  getWorkAddButtonTooltip(): string {
    if (!this.isLastWorkRowComplete()) {
      return 'Please complete the current work experience row before adding a new one';
    }
    if (this.hasWorkYearValidationErrors()) {
      return 'Please fix validation errors in work experience section before adding new rows';
    }
    return 'Add new work experience record';
  }

  // Setup conditional validation based on HasEducation
  setupHasEducationValidation(): void {
    this.educationaAndworkExperienceForm.get('HasEducation')?.valueChanges.subscribe((hasEducation: string | null) => {
      if (hasEducation === 'Yes') {
        // Apply validators to all existing education rows
        this.educationalFormArray.controls.forEach((control) => {
          control.get('DegreeName')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.get('SpecializationName')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.get('University')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.get('YearCompleted')?.setValidators([Validators.required, this.educationYearValidator.bind(this)]);
          control.get('DegreeName')?.updateValueAndValidity({ emitEvent: false });
          control.get('SpecializationName')?.updateValueAndValidity({ emitEvent: false });
          control.get('University')?.updateValueAndValidity({ emitEvent: false });
          control.get('YearCompleted')?.updateValueAndValidity({ emitEvent: false });
        });
      } else if (hasEducation === 'No') {
        // Clear validators from all education rows and clear values
        this.educationalFormArray.controls.forEach((control) => {
          control.get('DegreeName')?.clearValidators();
          control.get('SpecializationName')?.clearValidators();
          control.get('University')?.clearValidators();
          control.get('YearCompleted')?.clearValidators();
          control.get('DegreeName')?.setValue('', { emitEvent: false });
          control.get('SpecializationName')?.setValue('', { emitEvent: false });
          control.get('University')?.setValue('', { emitEvent: false });
          control.get('YearCompleted')?.setValue('', { emitEvent: false });
          control.get('DegreeName')?.updateValueAndValidity({ emitEvent: false });
          control.get('SpecializationName')?.updateValueAndValidity({ emitEvent: false });
          control.get('University')?.updateValueAndValidity({ emitEvent: false });
          control.get('YearCompleted')?.updateValueAndValidity({ emitEvent: false });
        });
      }
    });
  }

  // Setup conditional validation based on HasWorkExperience
  setupHasWorkExperienceValidation(): void {
    this.educationaAndworkExperienceForm.get('HasWorkExperience')?.valueChanges.subscribe((hasWorkExperience: string | null) => {
      if (hasWorkExperience === 'Yes') {
        // Apply validators to all existing work experience rows
        this.workExperienceFormArray.controls.forEach((control) => {
          control.get('CompanyName')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.get('JobDesignation')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.get('JobStartDate')?.setValidators([Validators.required, this.yearValidator.bind(this)]);
          control.get('JobEndDate')?.setValidators([Validators.required, this.yearValidator.bind(this)]);
          control.get('FieldTradeName')?.setValidators([Validators.required, Validators.maxLength(50)]);
          control.setValidators(this.workYearRangeValidator.bind(this));
          control.get('CompanyName')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobDesignation')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobStartDate')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobEndDate')?.updateValueAndValidity({ emitEvent: false });
          control.get('FieldTradeName')?.updateValueAndValidity({ emitEvent: false });
          control.updateValueAndValidity({ emitEvent: false });
        });
      } else if (hasWorkExperience === 'No') {
        // Clear validators from all work experience rows and clear values
        this.workExperienceFormArray.controls.forEach((control) => {
          control.get('CompanyName')?.clearValidators();
          control.get('JobDesignation')?.clearValidators();
          control.get('JobStartDate')?.clearValidators();
          control.get('JobEndDate')?.clearValidators();
          control.get('FieldTradeName')?.clearValidators();
          control.clearValidators();
          control.get('CompanyName')?.setValue('', { emitEvent: false });
          control.get('JobDesignation')?.setValue('', { emitEvent: false });
          control.get('JobStartDate')?.setValue('', { emitEvent: false });
          control.get('JobEndDate')?.setValue('', { emitEvent: false });
          control.get('FieldTradeName')?.setValue('', { emitEvent: false });
          control.get('CompanyName')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobDesignation')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobStartDate')?.updateValueAndValidity({ emitEvent: false });
          control.get('JobEndDate')?.updateValueAndValidity({ emitEvent: false });
          control.get('FieldTradeName')?.updateValueAndValidity({ emitEvent: false });
          control.updateValueAndValidity({ emitEvent: false });
        });
      }
    });
  }

}
